import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const MetaChange = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = import.meta.env.VITE_APP_NAME;
  }, [location.pathname]);
  return null;
};
